import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useRemoveLearningAssignmentsFromUsers() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({
      userUuids,
      learningItemUuids,
      assigningUserUuid,
    }: {
      userUuids: string[]
      learningItemUuids: string[]
      assigningUserUuid: string
    }) => {
      await api.del('course/unassign/learning-items-from-users', {
        users: userUuids,
        learning_items: learningItemUuids,
        assigningUserUuid: assigningUserUuid,
      })

      await Promise.all([invalidate.users(), invalidate.groups(), invalidate.courses()])
    },
  })
}
